
var React = require("react");
var DataContext = require("../DataContex.jsx");
var ApplicationContext = require("../config/ApplicationContext.js");

class Head extends React.Component {
    render() {
        return (
            <head>
                <meta charSet="utf-8" />
                <link rel="shortcut icon" type="image/x-icon" href={ApplicationContext.assetUrlPrefix + "/assets/libraryio.ico"} />
                <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no, minimal-ui" />
                <meta property="og:title" content="library.io" />
                <meta property="og:image" content={ApplicationContext.assetUrlPrefix + "/assets/banner-home.png"} />
                <title>{this.props.title}</title>
                <link rel="stylesheet" href={ApplicationContext.assetUrlPrefix + "/dist/main.bundle.css"} />
                <link rel="stylesheet" href={ApplicationContext.assetUrlPrefix + "/assets/viewer/style/viewerBundle.css"} />
                <DataContext {...this.props} />
                <script src={ApplicationContext.assetUrlPrefix + "/assets/viewer/js/3dviewerDependenciesBundle.js"} type="text/javascript" />
                <script src={ApplicationContext.assetUrlPrefix + "/assets/viewer/js/3dviewerBundle.js"} type="text/javascript" />

                <script dangerouslySetInnerHTML={{
                    __html: `
                    window.googleGA = window.googleGA || function() {
                        var params = arguments;
                        setTimeout(function() {
                            //Kevin: If tealium team does not fix the loading error, we need to uncomment this part
                            // if(params && params[0] == "create" ) {
                            //     window.googleGA.apply(null, [params[0], params[1]]);
                            // } else {
                                window.googleGA.apply(null, params);
                            // }
                        }, 1000);
                    };
                    `
                }}></script>
            </head>
        );
    }
}

module.exports = Head;
